import { Link } from 'react-router-dom';
import { useMenuData } from '@/hooks/useMenuData';
import { useCurrency } from '@/hooks/useCurrency';
import { SIGNATURE_COPY } from '@/content/yawasCopy';

const MenuPreviewSection = () => {
  const { products, loading } = useMenuData();
  const { format } = useCurrency();
  const featured = products.filter((p) => p.popular).slice(0, 6);

  return (
    <section id="menu-preview" className="py-20 md:py-28 bg-stone-50">
      <div className="max-w-7xl mx-auto px-4 md:px-8">
        <div className="flex flex-col md:flex-row md:items-end justify-between gap-6 mb-8">
          <div className="max-w-2xl">
            <span className="text-amber-500 text-sm font-semibold tracking-widest uppercase">{SIGNATURE_COPY.eyebrow}</span>
            <h2
              className="text-3xl md:text-5xl font-bold text-stone-900 mt-3"
              style={{ fontFamily: "'Playfair Display', serif" }}
            >
              {SIGNATURE_COPY.title}
            </h2>
            <p className="text-stone-500 text-base leading-relaxed mt-4">
              {SIGNATURE_COPY.text}
            </p>
          </div>
          <Link
            to="/menu"
            className="flex items-center gap-2 text-amber-600 font-semibold text-sm hover:gap-3 transition-all duration-200 cursor-pointer whitespace-nowrap"
          >
            {SIGNATURE_COPY.button}
            <div className="w-4 h-4 flex items-center justify-center">
              <i className="ri-arrow-right-line"></i>
            </div>
          </Link>
        </div>

        {loading ? (
          <div className="flex justify-center py-16">
            <div className="w-8 h-8 border-2 border-amber-500 border-t-transparent rounded-full animate-spin" />
          </div>
        ) : featured.length === 0 ? (
          <p className="text-center text-stone-400 text-sm py-12">Speisekarte wird vorbereitet.</p>
        ) : (
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
            {featured.map((item) => (
              <div
                key={item.id}
                className="group bg-white rounded-2xl overflow-hidden border border-stone-100 hover:border-amber-200 transition-all duration-300"
              >
                <div className="relative w-full h-52 overflow-hidden">
                  <img
                    src={item.image_url}
                    alt={item.name_de}
                    className="w-full h-full object-cover object-center group-hover:scale-105 transition-transform duration-500"
                  />
                  {item.badge_de && (
                    <span className="absolute top-3 left-3 px-3 py-1 bg-amber-500 text-white text-xs font-semibold rounded-full">
                      {item.badge_de}
                    </span>
                  )}
                  <div className="absolute bottom-3 right-3 px-3 py-1.5 bg-white/95 rounded-full text-stone-900 font-bold text-sm">
                    {format(item.price)}
                  </div>
                </div>
                <div className="p-5">
                  <h3 className="text-stone-900 font-semibold text-base mb-1.5">{item.name_de}</h3>
                  <p className="text-stone-500 text-sm leading-relaxed line-clamp-2">{item.description_de}</p>
                  <Link
                    to="/menu"
                    className="mt-4 w-full py-2.5 bg-stone-900 hover:bg-amber-500 text-white text-sm font-medium rounded-full transition-all duration-200 cursor-pointer whitespace-nowrap text-center block"
                  >
                    {SIGNATURE_COPY.button}
                  </Link>
                </div>
              </div>
            ))}
          </div>
        )}
      </div>
    </section>
  );
};

export default MenuPreviewSection;
